import React from 'react';

const FilterChips = ({
  predefinedFilters,
  activeFilter,
  onPresetClick,
  formData,
  onRemoveFilter
}) => {
  const getActiveFilterBadges = () => {
    const badges = [];

    if (formData.country && formData.country !== 'All') {
      badges.push({
        key: 'country',
        label: formData.country,
        icon: 'fa-globe'
      });
    }

    if (formData.sector && formData.sector !== 'All') {
      badges.push({
        key: 'sector',
        label: formData.sector,
        icon: 'fa-industry'
      });
    }

    if (activeFilter) {
      badges.push({
        key: 'preset',
        label: activeFilter.label,
        icon: 'fa-star',
        isPreset: true
      });
    }

    Object.entries(formData).forEach(([key, config]) => {
      if (typeof config === 'object' && config !== null && config.value > 0) {
        badges.push({
          key,
          label: `${config.label} ${config.isMax ? '\u2264' : '\u2265'} ${config.value}${config.unit || ''}`,
          icon: null
        });
      }
    });

    return badges;
  };

  const activeBadges = getActiveFilterBadges();
  const hasActiveFilters = activeBadges.length > 0;

  return (
    <div className="filter-chips-container">
      {/* Preset filter chips - always visible */}
      <div className="filter-chips-scroll">
        {predefinedFilters.map(filter => (
          <button
            key={filter.id}
            type="button"
            className={`filter-preset-btn${activeFilter && activeFilter.id === filter.id ? ' active' : ''}`}
            onClick={() => onPresetClick(filter)}
          >
            <i className="fas fa-star" aria-hidden="true"></i> {filter.label}
          </button>
        ))}
      </div>

      {/* Active filter badges - shown only when filters are active */}
      {hasActiveFilters && (
        <div className="active-filters-preview">
          {activeBadges.map(badge => (
            <span
              key={badge.key}
              className={`active-filter-tag${badge.isPreset ? ' preset' : ''}`}
            >
              {badge.icon && <i className={`fas ${badge.icon}`}></i>}
              {' '}{badge.label}
              <button
                type="button"
                className="filter-tag-remove"
                onClick={() => onRemoveFilter(badge.key)}
                aria-label={`${badge.label} entfernen`}
              >
                <i className="fas fa-times" aria-hidden="true"></i>
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterChips;
